import {
  openFullScreenPurchaseOverlay as openPurchaseOverlay,
  openFullScreenMemberOnlyOverlay as openMemberOnlyOverlay,
  openFullScreenSubscribeOverlay as openSubscribeOverlay,
  openFullScreenRentOverlay as openRentOverlay,
} from './open-overlay-base';
import { createProxy } from '../worker/lib';
import { isPricingPlanEnabled } from '@wix/wix-vod-shared/common';
import { PanoramaTransactionsNames } from '../constants/panorama-transactions-names';

export const openFullScreenPurchaseOverlay = createProxy(
  'openFullScreenPurchaseOverlay',
  (panoramaClient, ...args) =>
    (dispatch) => {
      panoramaClient
        .transaction(PanoramaTransactionsNames.CASHIER_MODAL_LOAD)
        .start();
      dispatch(openPurchaseOverlay(...args));
    },
);

export const openFullScreenMemberOnlyOverlay = createProxy(
  'openFullScreenMemberOnlyOverlay',
  (panoramaClient, ...args) =>
    (dispatch) => {
      panoramaClient
        .transaction(PanoramaTransactionsNames.CASHIER_MODAL_LOAD)
        .start();
      dispatch(openMemberOnlyOverlay(...args));
    },
);

export const openFullScreenSubscribeOverlay = createProxy(
  'openFullScreenSubscribeOverlay',
  (panoramaClient, channelId, callback) => (dispatch, getState) => {
    const {
      channelInfo: { info },
    } = getState();

    const isPlan = isPricingPlanEnabled(info);

    panoramaClient
      .transaction(PanoramaTransactionsNames.CASHIER_MODAL_LOAD)
      .start();
    dispatch(openSubscribeOverlay(channelId, callback, isPlan));
  },
);

export const openFullScreenRentOverlay = createProxy(
  'openFullScreenRentOverlay',
  (panoramaClient, ...args) =>
    (dispatch) => {
      panoramaClient
        .transaction(PanoramaTransactionsNames.CASHIER_MODAL_LOAD)
        .start();
      dispatch(openRentOverlay(...args));
    },
);
